export enum MenuActionId {
  HELP_MANUAL,
  HELP_CONTACT,
  HELP_TUTORIALS,
}
